import React = require("react");

// local
import {Title} from "../../../components/Title";
import {Loader} from "../../../components/Utils/loader/Loader";
import {WidgetResponse} from "../../DashboardContainer";
import {VeBoxCard} from "../../../components/card/VeBoxCard";

interface ListWidgetProps {
    data: WidgetResponse;
    title: string;
    onRowClick: Function;
    headerClassName?: string;
    nextToTitle?: JSX.Element;
}

interface ListWidgetState {
    title: string;
    response: ListData;
}

interface ListData {
    items: ListItem[];
}

export interface ListItem {
    id: number;
    id2: number;
    header: string;
    color: string;
    subHeader1: string;
    subHeader2: string;
    description: string;
    subDescription: string;
    imageName?: string;
}

export class ListWidget extends React.Component<ListWidgetProps, ListWidgetState> {

    constructor(props: ListWidgetProps) {
        super(props);

        this.state = {
            title: this.props.title,
            response: undefined,
        };

        this.retrieveData();
    }

    public render() {
        if (!this.state.response) {
            return <div className="list-widget">
                <Loader/>
            </div>;
        }
        if(this.state.response.items.length == 0){
            return null;
        }
        return (
            <VeBoxCard className="list-widget home-dashboard-card">
                <VeBoxCard.Header
                    className={"list-widget__header space-between " + (this.props.headerClassName || "")}
                    title={this.state.title.toUpperCase()}
                    titleClassName={"lowercase capitalize"}
                    back={this.props.nextToTitle}
                    singleLineTitle={true}
                />
                <VeBoxCard.Body className="list-widget__content" style={{padding: 0}}>
                    {this.renderList()}
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }

    public renderList() {
        return this.state.response.items.map((item, index) => {
            const hasSubDescription = item.subDescription && item.subDescription !== "";
            let subDescription = null;
            let headerClass = "list-widget__text-section-header";
            if (hasSubDescription) {
                subDescription = <p
                    className="list-widget__text-section-header list-widget__text-section-header--sub"
                    title={item.subDescription}
                    dangerouslySetInnerHTML={{__html: item.subDescription}}
                />;

            } else {
                headerClass = "list-widget__text-section-header list-widget__text-section-header--expanded";
            }
            // @ts-ignore
            return (
                <div
                    onClick={() => {
                        this.props.onRowClick(this.state.response.items[index]);
                    }}
                    key={index}
                    className="list-widget__row"
                >
                    <div className="list-widget__container list-widget__container--left">
                        <div
                            className={item.imageName == null ? "list-widget__color" : "list-widget__color-small"}
                            style={{
                                backgroundColor: item.color ? item.color : "",
                                ...( item.imageName ? {
                                    height: "90%",
                                    width: "5px",
                                    marginLeft: "-12px",
                                    marginTop: "2px",
                                    borderRadius: "30px",
                                } : undefined)
                            }}
                        />
                        <div
                            style={{
                                display: "flex",
                                height: "100%",
                            }}
                        >
                            {item.imageName != null ?
                                <div
                                    style={{
                                        display: "inline-block",
                                        position: "relative",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "var(--grey-20)",
                                            padding: "8px",
                                            border: "1px solid transparent",
                                            boxSizing: "border-box",
                                            borderRadius: "50%",
                                            width: "40px",
                                            height: "40px",
                                            position: "relative",
                                            top: "50%",
                                            transform: "translateY(-50%)"
                                        }}
                                    >
                                        <img
                                            className={item.imageName == null ? "list-widget__hidden" : "list-widget__image"}
                                            src={item.imageName}
                                            style={{
                                                margin: "0px",
                                            }}
                                        />
                                    </div>
                                </div>: null}
                            <div className="list-widget__text-section">
                                <span
                                    className="list-widget__text-section-header"
                                    dangerouslySetInnerHTML={{__html: item.header}}
                                />
                                <span
                                    className="list-widget__text-section-header list-widget__text-section-header--sub"
                                    title={item.subHeader1}
                                    dangerouslySetInnerHTML={{__html: item.subHeader1}}
                                />
                                <span
                                    className="list-widget__text-section-header list-widget__text-section-header--sub"
                                    title={item.subHeader2}
                                    dangerouslySetInnerHTML={{__html: item.subHeader2}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="list-widget__container list-widget__container--right">
                        <div className="list-widget__text-section">
                            <p
                                className={headerClass}
                                dangerouslySetInnerHTML={{__html: item.description}}
                            />
                            {subDescription}
                        </div>
                    </div>
                </div>
            );
        });
    }

    private retrieveData(): void {
        const dataUrl: string = this.props.data.dataUrl;
        Ajax.vbxAjax({
            url: dataUrl,
            type: "GET",
            cache: false,
            success: (response: ListData) => {
                this.setState({
                    response,
                });
            },
        });
    }
}
